import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
// import { initMercadoPago, Wallet } from "@mercadopago/sdk-react";
import { sendOrder } from "../../constants/order";
import { addEvent, loadUserConfig } from "../../constants/config";
import { UserConfigContext } from "../../context/UserConfigContext";
import { emailpedido } from "../../constants/products";
import { getDiscountedUnitPrice, getQuantityDiscount } from "../../constants/cartDiscounts";
import Swal from "sweetalert2";
import { resetCart } from "../../redux/orebiSlice";
import CryptoJS from "crypto-js";

import iconoMP from "../../assets/images/mercadopago.jpg"; // tu imagen local
import iconoMPQR from "../../assets/images/mercadopagoqr.png"; // tu imagen local

const Checkout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { config1, config2 } = useContext(UserConfigContext);
  const { products = [], shippingCharge = 0, total = 0 } = location.state || {};
  const [preferenceId, setPreferenceId] = useState(null);
  const [initPoint, setInitPoint] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mensajePago, setMensajePago] = useState("");
  const [notas, setNotas] = useState("");
  const [mostrarReintentar, setMostrarReintentar] = useState(false);

  const loggedUserData = JSON.parse(localStorage.getItem("user")) || {};
  const clienteFromStorage = loggedUserData?.data?.user || {};
  const cliente = clienteFromStorage;
  const user = clienteFromStorage;

  const { id_usuario = "", nrocli = "" } = clienteFromStorage;
  const { ip = "", dispositivo = "", tipo_dispositivo = "" } = loggedUserData?.data || {};

  const subtotal = products.reduce((acc, item) => {
    const precio = getDiscountedUnitPrice(item, item.quantity);
    return acc + precio * (item.quantity || 1);
  }, 0);

  const incIva = clienteFromStorage.incIva ?? 0;

  let totalConIva = 0;
  let ivaTotal = 0;

  products.forEach((item) => {
    const precio = getDiscountedUnitPrice(item, item.quantity);
    const cantidad = item.quantity || 1;
    const iva = item.iva ?? 0;
    const basePrice = precio * cantidad;

    if (incIva === 0) {
      totalConIva += basePrice * (1 + iva / 100);
      ivaTotal += basePrice * (iva / 100);
    } else {
      totalConIva += basePrice;
      ivaTotal += basePrice - basePrice / (1 + iva / 100);
    }
  });

  // useEffect(() => {
  //   const clientId = config1?.mercadopago?.clientid || "APP_USR-d00ff5cd-6017-4135-aeff-d6226d4ddd08";
  //   initMercadoPago(clientId);  // se llama solo una vez
  // }, []); // no dependes de config1, asÃ­ no se inicializa dos veces
  

  useEffect(() => {
    const procesarPago = async () => {
      const queryParams = new URLSearchParams(window.location.search);
      const status = queryParams.get("collection_status");
      const paymentId = queryParams.get("collection_id");
  
      if (status) {
        switch (status) {
          case "approved":
            setMensajePago("Pago aprobado correctamente!");
            try {
              const notasFinal = notas ? `${notas} | MP_ID: ${paymentId}` : `MP_ID: ${paymentId}`;
              const response = await sendOrder(
                cliente,
                products,
                clienteFromStorage.id_empresa || 0,
                clienteFromStorage.moneda || "ARS",
                clienteFromStorage.cotizacion || 1,
                notasFinal,
                clienteFromStorage.incIva || 0,
                paymentId
              );
  
              if (response.error) {
                Swal.fire({ icon: "error", title: "Hubo un error en el pedido", text: "Inténtalo de nuevo más tarde." });
                return;
              }
  
              const order_id = response.order_id;
              const nro_int_ped = response.nro_interno;
  
              for (const prod of products) {
               addEvent(id_usuario, nrocli, ip, dispositivo, tipo_dispositivo, 12, order_id, prod.codigo, prod.quantity, "", 1, nro_int_ped);
              }
  
             addEvent(id_usuario, nrocli, ip, dispositivo, tipo_dispositivo, 8, order_id, "", 1, "", 0, nro_int_ped);
  
              const ahora = new Date();
              const fecha = ahora.toLocaleDateString("es-AR");
              const hora = ahora.toLocaleTimeString("es-AR");
              const nro_sesion = Math.floor(100000 + Math.random() * 900000);
              const fechaHora = `${fecha} ${hora}`;
              const hashFechaHora = CryptoJS.MD5(fechaHora).toString();
              const sessionFinal = `${hashFechaHora} - ${nro_sesion}`;
              localStorage.setItem("session", sessionFinal);
  
              // ÃƒÂ°Ã…Â¸Ã‚Â§Ã‚Â¹ Limpia el carrito solo si estÃƒÆ’Ã‚Â¡ aprobado
              dispatch(resetCart());
  
              Swal.fire({ icon: "success", title: response.message || "Orden procesada exitosamente", text: "Volver a la Tienda..." }).then(async () => {
                try {
                  await emailpedido(response.nro_interno, user.email);
                } catch {
                  Swal.fire({ icon: "error", title: "Error al enviar el correo", text: "El pedido fue procesado, pero no se pudo enviar el correo." });
                }
                navigate("/");
              });
            } catch (error) {
              Swal.fire({ icon: "error", title: "Error al procesar orden", text: error?.response?.data?.message || "Intenta de nuevo mÃ¡s tarde." });
            }
            break;
  
          case "pending":
            setMensajePago("El pago está pendiente. Te notificaremos cuando se acredite.");
            break;
  
          case "rejected":
          case "failure":
            setMensajePago("El pago fue rechazado o falló. Intenta nuevamente.");
            setMostrarReintentar(true);
            break;
  
          default:
            setMensajePago("Estado del pago desconocido.");
        }
  
        // Limpia los parámetros de la URL
        const url = new URL(window.location);
        url.search = "";
        window.history.replaceState({}, document.title, url);
      }
    };
  
    procesarPago();
  }, []);
  
  useEffect(() => {
    if (!products || products.length === 0) {
      navigate("/cart");
      return;
    }

  }, [products, navigate, config1]);

  if (loading) return <p className="text-center mt-10">Cargando preferencia...</p>;
  // if (!preferenceId) return <p className="text-center mt-10">No hay productos para pagar.</p>;
  const handleClickMP = () => {
    // alert("Hiciste clic en Mercado Pago");
    Swal.fire({
      // title: "Pago con QR",
      text: "Checkout de Mercado Pago. Falta Configuración",
      // imageUrl: config1.mercadopago.qr,
      // imageWidth: 400,
      // imageHeight: 400,
      imageAlt: "Mercado Pago",
      showCloseButton: true,
      confirmButtonText: "Cerrar",
      confirmButtonColor: "#3085d6",
    });

  };

  // ÃƒÂ°Ã…Â¸Ã¢â‚¬ËœÃ¢â‚¬Â° FunciÃƒÆ’Ã‚Â³n que llama a la API externa
  const llamarApiExterna = async (monto, referencia) => {
    try {
      // const token = "161138a181d18372dc3e7cdf05adf7a0"; // reemplazá con tu token real
      const token = process.env.REACT_APP_URL_APITOKEN;
      const access_token_checkout = config1?.mercadopago?.token_checkout;
      const access_token_qr = config1?.mercadopago?.token_qr;
      const pos_id = config1?.mercadopago?.pos_id;
      const descripcion = config1?.id_empresa?.nombre;

      const url_api_pagos = process.env.REACT_APP_URL_APIPAGOS;
      const response = await fetch(`${url_api_pagos}mercadopago/genera_pago_qr`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // 'Authorization': `Bearer ${token}`, // token en header
          'Authorization': 'Basic ' + btoa('hinetService:99RHinet202'), // Autenticación básica
        },
        body: JSON.stringify({
          access_token: access_token_qr,
          pos_id: pos_id,
          importe: monto,
          descripcion: descripcion,
          external_reference: referencia,
        }),
      });

      const data = await response.json();

      console.log("ÃƒÂ¢Ã…â€œÃ¢â‚¬Â¦ Respuesta de la API:", data);

      // // opcional: mostrar respuesta en un modal
      // Swal.fire({
      //   icon: "success",
      //   title: "Respuesta de la API",
      //   text: JSON.stringify(data, null, 2),
      //   confirmButtonText: "Cerrar",
      // });

      return data;
    } catch (error) {
      console.error("ÃƒÂ¢Ã‚ÂÃ…â€™ Error en la API:", error);

      Swal.fire({
        icon: "error",
        title: "Error en la API",
        text: (error.message == '' ? ' No se pudo Comunicar con la API para Procesar el Pago': error.message),
        confirmButtonText: "Cerrar",
      });
    }
  }
  
  // Consulta el estado del pago hasta que sea true
  const consultarEstadoPago = async (order_id) => {
    const token = process.env.REACT_APP_URL_APITOKEN;
    let intentos = 0;
    const maxIntentos = 20; // número máximo de consultas
    const intervalo = 3000; // 3 segundos entre consultas

    return new Promise((resolve) => {
      const intervalId = setInterval(async () => {
        intentos++;
        console.log(`ÃƒÂ°Ã…Â¸Ã¢â‚¬ÂÃ¢â‚¬Å¾ Consultando estado... intento ${intentos}`);

        try {
          const url_api_pagos = process.env.REACT_APP_URL_APIPAGOS;
          const access_token = config1?.mercadopago?.token;
          const resp = await fetch(`${url_api_pagos}mercadopago/recuperar_pago_qr`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              access_token: access_token,
              order_id: order_id,
            }),
          });
          const data = await resp.json();
          console.log(data);
          if (data?.order.status === 'processed') {
            console.log("ÃƒÂ¢Ã…â€œÃ¢â‚¬Â¦ Pago confirmado:", data);
            clearInterval(intervalId);
            resolve(true);

            Swal.fire({
              icon: "success",
              title: "Pago confirmado",
              text: "El pago fue procesado correctamente.",
              confirmButtonText: "Cerrar",
            });
          } else if (intentos >= maxIntentos) {
            console.warn("ÃƒÂ¢Ã…Â¡Ã‚Â ÃƒÂ¯Ã‚Â¸Ã‚Â Tiempo de espera agotado");
            clearInterval(intervalId);
            resolve(false);

            Swal.fire({
              icon: "warning",
              title: "Tiempo de espera agotado",
              text: "No se confirmó el pago.",
              confirmButtonText: "Cerrar",
            });
          }
        } catch (err) {
          console.error("ÃƒÂ¢Ã‚ÂÃ…â€™ Error al consultar el estado:", err);
        }
      }, intervalo);
    });
  };

  const handleClickQR = async () => {
    // alert("Hiciste clic en Mercado Pago QR");

    Swal.fire({
      // title: "Pago con QR",
      text: "Escaneá el código con la app de Mercado Pago",
      imageUrl: config1.mercadopago.qr,
      imageWidth: 400,
      imageHeight: 400,
      imageAlt: "Mercado Pago QR",
      showCloseButton: true,
      confirmButtonText: "Cerrar",
      confirmButtonColor: "#3085d6",
    });

    // ÃƒÂ°Ã…Â¸Ã¢â‚¬ÂÃ‚Â¹ Llamada a la API con parámetros
    await llamarApiExterna(totalConIva, `PEDIDO_${Math.floor(100000+Math.random()*90000)}` );

  };
  return (
    <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-6 px-4 py-8">
      <div className="flex-grow basis-0 bg-white shadow-md p-6 rounded-lg">
        <h2 className="text-xl font-semibold mb-6 border-b pb-2">Opciones de Pago</h2>

        <div className="flex justify-center items-center gap-6 py-8">
          <button
            onClick={handleClickMP}
            className="transition-transform duration-200 hover:scale-105 hover:opacity-90 focus:outline-none"
          >
            <img
              src={iconoMP}
              alt="Mercado Pago"
              className="w-32 h-auto rounded-lg shadow hover:shadow-lg"
            />
          </button>

          <button
            onClick={handleClickQR}
            className="transition-transform duration-200 hover:scale-105 hover:opacity-90 focus:outline-none"
          >
            <img
              src={iconoMPQR}
              alt="Mercado Pago QR"
              className="w-32 h-auto rounded-lg shadow hover:shadow-lg"
            />
          </button>
        </div>

        {/* {preferenceId && (
          <Wallet initialization={{ preferenceId }} />
        )} */}

        {/* {mensajePago && (
          <div className="mt-4 p-4 rounded-md border bg-gray-50 text-gray-700 text-sm">
            {mensajePago}
          </div>
        )}

        {mensajePago && (
          <div className="mensaje-pago">
            <p>{mensajePago}</p>
            {mostrarReintentar && (
              <button
                onClick={() => navigate("/ecommerce/checkout")}
                className="btn btn-danger mt-2"
              >
                Reintentar pago
              </button>
            )}
          </div>
        )} */}

      </div>

      <div className="flex-grow basis-0 bg-white shadow-md p-6 rounded-lg">
        <h2 className="text-xl font-semibold mb-6 border-b pb-2">Resumen de compra</h2>
        <div className="max-h-[300px] overflow-y-auto pr-2">
          <ul className="divide-y">
            {products.map((product, index) => {
              const descuento = getQuantityDiscount(product, product.quantity);
              const precioUnitario = getDiscountedUnitPrice(product, product.quantity);
              const totalItem = precioUnitario * (product.quantity || 1);
              return (
                <li key={index} className="flex gap-4 py-4 items-start">
                  <img src={product.img} alt={product.Descripcion} className="w-14 h-14 object-cover rounded" />
                  <div className="flex flex-col flex-grow">
                    <p className="font-semibold">{product.codigo}</p>
                    <p className="text-sm text-gray-500">{product.Descripcion}</p>
                    <p className="text-sm mt-1">Cantidad: <strong>{product.quantity || 1}</strong></p>
                    {descuento.porcentaje > 0 && (
                      <p className="text-sm text-green-700">Descuento: <strong>{descuento.porcentaje}%</strong></p>
                    )}
                  </div>
                  <div className="text-right">
                    <p className="text-sm">Unitario: <span className="font-medium">${parseFloat(precioUnitario).toFixed(2)}</span></p>
                    <p className="text-sm mt-1 font-bold text-black">Total: ${parseFloat(totalItem).toFixed(2)}</p>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="mt-6 pt-4 border-t">
          <div className="flex justify-between text-base text-gray-700 mb-2">
            <span>Subtotal</span>
            <span>${subtotal.toFixed(2)}</span>
          </div>

          {shippingCharge > 0 && (
            <div className="flex justify-between text-base text-gray-700 mb-2">
              <span>Envío</span>
              <span>${shippingCharge.toFixed(2)}</span>
            </div>
          )}

          <div className="flex justify-between text-base text-gray-700 mb-2">
            <span>IVA</span>
            <span>${ivaTotal.toFixed(2)}</span>
          </div>

          <div className="flex justify-between text-xl font-bold text-black mt-4 border-t pt-4">
            <span>Total a pagar</span>
            <span>${(totalConIva + shippingCharge).toFixed(2)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
